import { useInitializeAccountData } from "hooks/useInitializeAccountData"
import { NotFoundPage } from "pages/error/404"
import React, { useEffect } from "react"
import { useRecoilValue } from "recoil"
import {
  isClientNotFoundState,
  isCompanyNotFoundState,
} from "recoils/isNotFoundState"
import styled from "styled-components"

import { Button } from "../../components/atoms/Button"
import { Detail, DetailTitle } from "../../components/atoms/detail"

export const PlanPage = (): JSX.Element => {
  const email = process.env.REACT_APP_CONTACT_EMAIL || ""

  const isClientNotFound = useRecoilValue(isClientNotFoundState)
  const isCompanyNotFound = useRecoilValue(isCompanyNotFoundState)
  const initialize = useInitializeAccountData()

  useEffect(() => {
    initialize().catch((e: any) => console.warn(e))
  }, [])

  if (isClientNotFound || isCompanyNotFound) {
    return <NotFoundPage />
  }

  return (
    <Detail>
      <DetailTitle>プラン情報</DetailTitle>
      <p>割引プランをご契約いただくことでさらにお得にご活用いただけます。</p>
      <StyledTable>
        <thead>
          <StyledTr>
            <StyledTh></StyledTh>
            <StyledTh>無料プラン</StyledTh>
            <StyledTh>プランA</StyledTh>
            <StyledTh>プランG</StyledTh>
          </StyledTr>
        </thead>
        <tbody>
          <StyledTr>
            <StyledTd>月額基本料金</StyledTd>
            <StyledTd>無料</StyledTd>
            <StyledTd>¥55,000(税込)</StyledTd>
            <StyledTd>¥165,000(税込)</StyledTd>
          </StyledTr>
          <StyledTr>
            <StyledTd>会社名掲載</StyledTd>
            <StyledTd>○</StyledTd>
            <StyledTd>◯</StyledTd>
            <StyledTd>◯</StyledTd>
          </StyledTr>
          <StyledTr>
            <StyledTd>電話番号掲載</StyledTd>
            <StyledTd>○</StyledTd>
            <StyledTd>◯</StyledTd>
            <StyledTd>◯</StyledTd>
          </StyledTr>
          <StyledTr>
            <StyledTd>ホームページURL掲載</StyledTd>
            <StyledTd>-</StyledTd>
            <StyledTd>-</StyledTd>
            <StyledTd>◯</StyledTd>
          </StyledTr>
          <StyledTr>
            <StyledTd>メールアドレス掲載</StyledTd>
            <StyledTd>-</StyledTd>
            <StyledTd>-</StyledTd>
            <StyledTd>◯</StyledTd>
          </StyledTr>
          <StyledTr>
            <StyledTd>求人イメージ画像の掲載</StyledTd>
            <StyledTd>-</StyledTd>
            <StyledTd>◯(最大2枚まで)</StyledTd>
            <StyledTd>◯(最大3枚まで)</StyledTd>
          </StyledTr>
          <StyledTr>
            <StyledTd>
              求人イメージ動画
              <br />
              (YouTube動画)の掲載
            </StyledTd>
            <StyledTd>-</StyledTd>
            <StyledTd>-</StyledTd>
            <StyledTd>◯</StyledTd>
          </StyledTr>
          <StyledTr>
            <StyledTd>登録者閲覧履歴の確認</StyledTd>
            <StyledTd>-</StyledTd>
            <StyledTd>◯</StyledTd>
            <StyledTd>◯</StyledTd>
          </StyledTr>
          <StyledTr>
            <StyledTd>気になるボタンによるアピール</StyledTd>
            <StyledTd>-</StyledTd>
            <StyledTd>-</StyledTd>
            <StyledTd>◯</StyledTd>
          </StyledTr>
          <StyledTr>
            <StyledTd>
              求職者プロフィール登録者のみに見せる
              <br />
              非掲載機能
            </StyledTd>
            <StyledTd>-</StyledTd>
            <StyledTd>-</StyledTd>
            <StyledTd>◯</StyledTd>
          </StyledTr>
        </tbody>
      </StyledTable>

      <PaymentInfo>
        <p>
          有料プランをご利用の方は、下記の口座までお振込みをお願いいたします。
        </p>
        <PaymentBox>
          <dl>
            <dt>銀行名</dt>
            <dd>セブン銀行（0034）</dd>
            <dt>支店名</dt>
            <dd>カーネーション支店（105）</dd>
            <dt>口座番号</dt>
            <dd>2782918</dd>
            <dt>口座名義</dt>
            <dd>アマン ケイタ</dd>
          </dl>
        </PaymentBox>

        <p>
          振込後には、「プラン変更についてお問い合わせ」ボタンよりご連絡ください。
          <br />
          原則として、振込後の翌月1日からプランが適用されます。
          <br />
          <br />※ 振込手数料はご負担くださいますようお願いいたします。
        </p>
      </PaymentInfo>

      <StyledCenter>
        <a
          href={
            "mailto:" + email + "?subject=【船員求人広告】有料プランに関して"
          }
        >
          <Button>プラン変更についてお問い合わせ</Button>
        </a>
      </StyledCenter>
    </Detail>
  )
}

const StyledTable = styled.table`
  margin-bottom: 20px;
  width: 100%;
`

const StyledTh = styled.th`
  padding: 15px;
  font-size: 16px;
  background: #f2f2f2;
  border: 1px solid rgba(0, 0, 0, 0.03);
`

const StyledTr = styled.tr`
  font-size: 16px;
`

const StyledTd = styled.td`
  padding: 15px;
  text-align: center;

  &:first-child {
    text-align: left;
    background: #fafafa;
  }
  border: 1px solid rgba(0, 0, 0, 0.03);
`

const PaymentInfo = styled.div`
  margin-bottom: 20px;
`

const PaymentBox = styled.div`
  width: 300px;
  margin: 10px 0;
  padding: 20px 20px 10px;
  background: #fafafa;
`

const StyledCenter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
